import { checkUndefined } from "./checkUndefined";
import { firelikeId } from "./firelikeid";

export const CheckSelectedItem = (item) => {
  const checkBundleItem = (bundleItems) => {
    const items = checkUndefined(bundleItems, []);
    return items.map((i) => {
      return {
        bundleItemDesc: i?.bundleItemDesc ?? "",
        bundleItemId: i?.bundleItemId ?? "",
        bundleItemName: i?.bundleItemName ?? "",
        bundleItemQty: i?.bundleItemQty ?? 0,
        bundleItemTurnaround: i?.bundleItemTurnaround ?? null,
      };
    });
  };
  return {
    bundleItems: checkBundleItem(item?.bundleItems),
    bundleItemsQueryHook: item?.bundleItemsQueryHook ?? [],
    categories: item?.categories ?? [],
    categoriesQueryHook: item?.categoriesQueryHook ?? [],
    id: item?.id ?? "",
    description: item?.description ?? "",
    image: item?.image ?? null,
    inheritParentTurnaround: item?.inheritParentTurnaround ?? false,
    turnaround: item?.turnaround ?? 0,
    isActive: item?.isActive ?? false,
    isAvailable: item?.isAvailable ?? false,
    isTaxable: item?.isTaxable ?? false,
    key: item?.key ?? 0,
    listIndex: item?.listIndex ?? (item?.key ?? 0),
    name: item?.name ?? "",
    notes: item?.notes ?? "",
    orgId: item?.orgId ?? "",
    qbId: item?.qbId ?? "",
    rates: item?.rates ?? [],
    type: item?.type ?? "rental",                                   // "rental" | "bundle" | "sale"
    uuid: item?.uuid ?? firelikeId(),
    
    selectedDuration: item?.selectedDuration ?? 0,
    selectedItemId: item?.selectedItemId ?? item?.id ?? "",
    selectedQty: item?.selectedQty ?? 0,
    selectedRate: item?.selectedRate ?? "",
    selectedRateMeta: checkRateMeta(item?.selectedRateMeta),
    
    weight: item?.weight ?? null,
    volume: item?.volume ?? null,
    dimensions: item?.dimensions ?? null,
    stackable: item?.stackable ?? false,
    routingConstraints: item?.routingConstraints ?? "",
    requiresTwoPeople: item?.requiresTwoPeople ?? false,
    informationURL: item?.informationURL ?? null,
    shopFrontURL: item?.shopFrontURL ?? null,
    picklistInfo: item?.picklistInfo ?? null,
    includeInPicklist: item?.includeInPicklist ?? true,
    
    // Shared Props between special and regular items
    rowTotal: item?.rowTotal ?? 0,
    rowType: item?.rowType ?? "singleItem",                                   // subtotal | damageWaiver | flatFee | percentFee | label | discount | == | singleItem
    selectedTaxable: item?.selectedTaxable ?? false,
    selectedDescription: item?.selectedDescription ?? "",
    
    // Special Item Props
    damageWaiverPercentage: item?.damageWaiverPercentage ?? null,
    discountType: item?.discountType ?? null,                       // percent | number
    discountValue: item?.discountValue ?? null,                     // number - amount will be whole number in pennies, percent will be whole number 0-100
    percentFee: item?.percentFee ?? null, 
    percentFeeApplyToAll: item?.percentFeeApplyToAll ?? false,

    linkedItemQueryHooks: item?.linkedItemQueryHooks ?? [],
    addOnItemQueryHooks: item?.addOnItemQueryHooks ?? [],
    replacementItemQueryHooks: item?.replacementItemQueryHooks ?? [],
    vendorsQueryHook: item?.vendorsQueryHook ?? [],
  };
};

const checkRateMeta = (rate) => {
  return {
    rate: rate?.rate ?? 0,
    rateName: rate?.rateName ?? "Unknown Rate",
    rateRange: rate?.rateRange ?? null,
  };
};
